<template>
  <div :style="'padding-right:' + right + 'px'">
    <v-dialog v-model="dialogs.delete" max-width="250">
      <action-form
        v-if="dialogs.delete"
        :item="toolbar.deleteItem"
        v-on:close="dialogs.delete = false"
        v-on:remove="remove"
      ></action-form>
    </v-dialog>

    <v-dialog v-model="dialogs.transfer" max-width="250">
      <transfer
        v-if="dialogs.transfer"
        :item="toolbar.deleteItem"
        v-on:close="dialogs.transfer = false"
        v-on:transfer="transfer"
      ></transfer>
    </v-dialog>

    <v-app-bar
      v-if="!mobileVersion"
      :height="35"
      color="transparent"
      flat
      class="pr-1"
    >
      <v-toolbar-title>
        <v-breadcrumbs
          class="pa-0 mb-1 ml-3"
          :items="account.pathItems"
          divider=">"
        ></v-breadcrumbs>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu offset-y bottom transition="slide-y-transition" left>
        <template v-slot:activator="{ on }">
          <div
            class="px-2"
            v-bind:class="
              mobileVersion
                ? 'subtitle font-weight-medium'
                : 'subtitle-1 font-weight-medium'
            "
            v-if="location"
            v-on="on"
            style="color: #bbbbbb"
          >
            <font-awesome-icon
              class="mr-1"
              icon="circle"
              size="sm"
              :style="{ color: location.name === 'Demo' ? 'red' : 'green' }"
            />
            <span
              :style="
                $vuetify.breakpoint.xs ? 'max-width:200px;overflow:hidden' : ''
              "
              >{{ location.name }}</span
            >

            <font-awesome-icon class="ml-1" icon="caret-down" size="sm" />
          </div>
        </template>

        <v-list subheader two-line v-if="location !== null">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium headline mb-2"
                >Locations</v-list-item-title
              >
              <v-list-item-subtitle>Change your location</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>
          <template v-for="(item, indexStore) in locations">
            <v-list-item :key="indexStore" @click="selectLocation(item)">
              <v-list-item-action>
                <font-awesome-icon
                  icon="circle"
                  :style="{ color: item.name === 'Demo' ? 'red' : 'green' }"
                />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title v-text="item.name"></v-list-item-title>
                <v-list-item-title
                  class="caption font-weight-medium"
                  style="opacity: 0.5"
                  v-if="item._id === account.user.defaultLocation"
                  >Default</v-list-item-title
                >
                <v-list-item-subtitle
                  class="caption font-weight-medium"
                  v-bind:style="
                    item.name === 'Demo' ? 'color:red' : 'color:green'
                  "
                  >{{
                    item.name === "Demo" ? "TEST" : "LIVE"
                  }}</v-list-item-subtitle
                >
              </v-list-item-content>

              <v-list-item-action>
                <font-awesome-icon
                  color="secondary"
                  :icon="
                    item._id === location._id
                      ? 'check-square'
                      : ['far', 'square']
                  "
                  size="lg"
                  :style="{ color: 'blue' }"
                />
              </v-list-item-action>
            </v-list-item>
            <v-divider :key="indexStore + 100"></v-divider>
          </template>
          <div class="text-xs-center">
            <v-subheader>
              <a href="/settings/account">Manage locations</a>
            </v-subheader>
          </div>
          <v-divider></v-divider>
          <div
            v-if="!mobileVersion && account.user.role == 'owner'"
            class="pa-1 subtitle-1 text-xs-center"
          >
            {{ account.company.name }}
          </div>
        </v-list>
      </v-menu>

      <v-btn small class="ml-1" icon @click="reload">
        <v-tooltip bottom color="secondary">
          <template v-slot:activator="{ on }">
            <font-awesome-icon
              v-on="on"
              icon="sync-alt"
              size="lg"
              :style="{ color: '#bbbbbb' }"
            />
          </template>
          <span>Reload</span>
        </v-tooltip>
      </v-btn>

      <v-menu offset-y bottom transition="slide-y-transition" left>
        <template v-slot:activator="{ on }">
          <v-btn small class="ml-1" slot="activator" icon v-on="on">
            <v-tooltip bottom color="secondary">
              <template v-slot:activator="{ on }">
                <font-awesome-icon
                  v-on="on"
                  icon="ellipsis-v"
                  size="lg"
                  :style="{ color: '#bbbbbb' }"
                />
              </template>
              <span>More</span>
            </v-tooltip>
          </v-btn>
        </template>
        <v-list>
          <div class="pa-2 pl-3 pr-3">
            <div class="font-weight-medium headline">
              {{ account.user.name }}
            </div>
            <v-list-item-subtitle>{{
              account.user.email
            }}</v-list-item-subtitle>
          </div>
          <v-divider></v-divider>
          <v-list-item to="/settings/accounts">
            <v-list-item-action>
              <font-awesome-icon icon="user" size="lg" />
            </v-list-item-action>
            <v-list-item-content>Profile</v-list-item-content>
          </v-list-item>
          <v-list-item
            v-for="item in userItems"
            :key="item.title"
            :to="item.link"
          >
            <v-list-item-action>
              <font-awesome-icon :icon="item.icon" size="lg" />
            </v-list-item-action>
            <v-list-item-content>{{ item.title }}</v-list-item-content>
          </v-list-item>
          <v-list-item @click="signout">
            <v-list-item-action>
              <font-awesome-icon icon="sign-out-alt" size="lg" />
            </v-list-item-action>
            <v-list-item-content>Log out</v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-container fluid :style="'padding:10px;padding-top:0px'">
      <div style="height: 5px">
        <v-progress-linear
          v-if="loading"
          height="5"
          indeterminate
          color="secondary"
        ></v-progress-linear>
      </div>
      <v-card>
        <div
          v-if="toolbar"
          class="px-3 d-flex align-center justify-space-between header"
        >
          <div class="text-h6">{{ toolbar.title }}</div>
          <v-btn-toggle dense class="actions">
            <v-tooltip bottom color="blue">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  style="min-width: 35px"
                  :disabled="!toolbar.add"
                  @click="add"
                >
                  <font-awesome-icon
                    icon="plus"
                    size="lg"
                    :style="{ color: !toolbar.add ? 'grey' : 'blue' }"
                  />
                </v-btn>
              </template>
              <span>New</span>
            </v-tooltip>

            <v-tooltip bottom color="green">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  style="min-width: 35px"
                  :disabled="!toolbar.save"
                  @click="save"
                >
                  <font-awesome-icon
                    icon="save"
                    size="lg"
                    :style="{ color: !toolbar.save ? 'grey' : 'green' }"
                  />
                </v-btn>
              </template>
              <span>Save</span>
            </v-tooltip>

            <template v-if="toolbar.clear">
              <v-tooltip bottom color="orange">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" style="min-width: 35px" @click="clear">
                    <font-awesome-icon
                      icon="redo"
                      size="lg"
                      :style="{ color: 'orange' }"
                    />
                  </v-btn>
                </template>
                <span>Clear</span>
              </v-tooltip>
            </template>
            <template v-if="toolbar.delete">
              <v-tooltip bottom color="red">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" style="min-width: 35px" @click="remove">
                    <font-awesome-icon
                      icon="trash"
                      size="lg"
                      :style="{ color: 'red' }"
                    />
                  </v-btn>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </template>
            <template v-if="toolbar.transfer">
              <v-tooltip bottom color="orange">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" style="min-width: 35px" @click="transfer">
                    <font-awesome-icon
                      icon="random"
                      size="lg"
                      :style="{ color: 'orange' }"
                    />
                  </v-btn>
                </template>
                <span>Transfer Location</span>
              </v-tooltip>
            </template>
          </v-btn-toggle>
          <!-- <div>
            <span v-if="toolbar.add">
              <v-tooltip bottom color="blue">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" color="blue" dark @click="add">
                    <font-awesome-icon icon="plus" size="lg" />
                  </v-btn>
                </template>
                <span>New</span>
              </v-tooltip>
            </span>
            <span v-if="toolbar.save != null">
              <v-tooltip bottom color="green">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="green"
                    :dark="toolbar.save"
                    :disabled="!toolbar.save"
                    class="ml-2"
                    @click="save"
                  >
                    <font-awesome-icon icon="save" size="lg" />
                  </v-btn>
                </template>
                <span>Save</span>
              </v-tooltip>
            </span>
            <span v-if="toolbar.clear">
              <v-tooltip bottom color="orange">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="orange"
                    dark
                    class="ml-2"
                    @click="clear"
                  >
                    <font-awesome-icon icon="redo" size="lg" />
                  </v-btn>
                </template>
                <span>Clear</span>
              </v-tooltip>
            </span>
            <span v-if="toolbar.delete">
              <v-tooltip bottom color="red">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="red"
                    dark
                    class="ml-2"
                    @click="remove"
                  >
                    <font-awesome-icon icon="trash" size="lg" />
                  </v-btn>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </span>
            <span v-if="toolbar.transfer">
              <v-tooltip bottom color="orange">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="orange"
                    dark
                    class="ml-2"
                    @click="transfer"
                  >
                    <font-awesome-icon icon="random" size="lg" />
                  </v-btn>
                </template>
                <span>Transfer Location</span>
              </v-tooltip>
            </span>
          </div> -->
        </div>
        <v-divider></v-divider>
        <slot name="content"></slot>
      </v-card>
      <div
        @mouseover="sidebar.isHovering = true"
        @mouseleave="sidebar.isHovering = false"
      >
        <v-navigation-drawer
          v-if="sidebar"
          v-model="account.drawerRight"
          fixed
          class="elevation-4 navDrawerRight"
          right
          :mini-variant="!pinned"
          :mini-variant-width="
            sidebar.isHovering ? sidebar.width + 'px' : miniWidth + 'px'
          "
          :expand-on-hover="!pinned"
          :width="sidebar.width"
        >
          <v-subheader class="title">
            {{ sidebar.title }}
            <v-spacer></v-spacer>
            <font-awesome-icon
              color="primary"
              :style="{
                opacity:
                  +sidebar.isHovering || pinned ? (pinned ? 1.0 : 0.5) : 0,
                color: 'grey',
              }"
              @click="pinned = !pinned"
              icon="thumbtack"
            />
          </v-subheader>
          <v-divider></v-divider>
          <div v-if="search" class="py-1 white" elevation="1">
            <!-- <div
              @mouseover="expandSearch = true"
              @mouseleave="expandSearch = false"
            >-->
            <div>
              <div class="pa-1">
                <v-text-field
                  background-color="white"
                  placeholder="Search"
                  single-line
                  solo
                  flat
                  dense
                  hide-details
                  extended
                  v-model="search.term"
                  @click="expandSearch = true"
                  autocomplete="off"
                >
                  <template v-slot:prepend-inner>
                    <font-awesome-icon icon="search" class="mr-1" />
                  </template>
                  <template v-slot:append>
                    <font-awesome-icon icon="times" @click="search.term = ''" />
                  </template>
                </v-text-field>
              </div>
              <div>
                <v-expand-transition>
                  <v-card v-show="expandSearch" id="sidebar1">
                    <v-select
                      v-model="search.type"
                      attach="#sidebar1"
                      :items="searchItems"
                      label="Search type"
                      hide-details
                      filled
                    ></v-select>
                  </v-card>
                </v-expand-transition>
              </div>
            </div>
          </div>
          <v-divider></v-divider>

          <slot name="sidebar"></slot>
        </v-navigation-drawer>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import transfer from "@/components/transfer";

export default {
  props: {
    sidebar: Object,
    search: Object,
    searchItems: Array,
    toolbar: Object,
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    transfer,
  },
  data() {
    return {
      pinned: false,
      miniWidth: 150,
      dialogs: {
        delete: false,
        transfer: false,
      },
      expandSearch: true,
      searchType: null,
      userItems: [
        { icon: "cog", title: "Settings", link: "/settings" },
        { icon: "question-circle", title: "Help", link: "/help" },
      ],
    };
  },
  watch: {
    // "sidebar.isHovering": function (v) {
    //   console.log(this.sidebar.isHovering);
    // },
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),

    right() {
      return !this.sidebar || this.mobileVersion
        ? 0
        : this.pinned
        ? this.sidebar.width
        : this.miniWidth;
    },
    padding() {
      return 20;
    },
    mobileVersion() {
      var mobile = this.$vuetify.breakpoint.mdAndDown;
      if (!mobile) {
        this.account.drawerRight = true;
      }
      return mobile;
    },
    miniPadding() {
      return this.mobileVersion ? 0 : 30;
    },
    miniMargin() {
      return this.account.drawerLeftWidth - this.miniPadding;
    },

    topMargin() {
      return this.mobileVersion ? 50 : 0;
    },
    location() {
      return this.account.location;
    },
    locations() {
      return this.account.locations;
    },
  },
  methods: {
    ...mapActions({
      logout: "account/logout",
      changeLocation: "account/changeLocation",
      toggleDrawerLeft: "account/toggleLeftDrawer",
    }),
    hideOverlay() {
      this.sidebar.visible = false;
    },
    focusSearchType() {
      console.log("focus");
    },
    add() {
      this.$emit("add");
    },
    save() {
      this.$emit("save");
    },
    clear() {
      this.$emit("clear");
    },
    transfer(id) {
      if (this.dialogs.transfer) {
        this.$emit("transfer", id);
        this.dialogs.transfer = false;
      } else {
        this.dialogs.transfer = true;
      }
    },
    remove() {
      if (this.dialogs.delete) {
        this.$emit("remove");
        this.dialogs.delete = false;
      } else {
        this.dialogs.delete = true;
      }
    },
    selectLocation(location) {
      this.changeLocation(location);
      // this.$tabs.reset("/");
      this.$router.push("/");
    },
    signout() {
      this.logout();
      this.$router.push("/login");
    },
    reload() {
      window.location.reload(true);
    },
  },
  mounted() {
    if (this.sidebar && this.sidebar.pinned != null) {
      this.pinned = this.sidebar.pinned;
    } else {
      this.pinned = !this.mobileVersion;
    }
  },
};
</script>


<style>
.actions .theme--light.v-btn {
  color: transparent !important;
}
</style>

